import type { genderType, loginResponseType, occupationType, visaType } from 'apis/handler/auth/authSchema';
import { ApiError, apiClient } from 'shared/api';
import { BaseResponseType } from 'shared/api';

export const patchPassword = async ({
  password,
  passwordConfirm,
  resetPasswordToken,
}: {
  password: string;
  passwordConfirm: string;
  resetPasswordToken: string;
}): Promise<BaseResponseType<string>> => {
  const { data } = await apiClient.patch('/auth/member/change-password', {
    password,
    passwordConfirm,
    resetPasswordToken,
  });

  // NOTE: 현재 실패한 요청에도 http code를 200으로 받고 있기 때문에 아래와 같이 처리합니다
  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data;
};

export const postEmailCertification = async (email: string): Promise<BaseResponseType<string>> => {
  const { data } = await apiClient.post('/auth/member/email-certification', { email });

  // NOTE: 현재 실패한 요청에도 http code를 200으로 받고 있기 때문에 아래와 같이 처리합니다
  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data;
};

export type GoogleLoginReqDto = {
  idToken: string;
  preferredLanguageCode: string;
};

export const postGoogleLogin = async (body: GoogleLoginReqDto): Promise<loginResponseType> => {
  const { data } = await apiClient.post('/auth/member/login/google', body);

  // NOTE: 현재 실패한 요청에도 http code를 200으로 받고 있기 때문에 아래와 같이 처리합니다
  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data.result;
};

export type ProfileCompleteReqDto = {
  firstName: string;
  lastName: string;
  genderType: genderType;
  birth: string;
  phoneNumber: string;
  countryCode: string;
  nationality: string;
  occupationType: occupationType;
  visaType: visaType;
  preferredLanguageCode: string;
  marketingConsent: boolean;
  referralCode?: string;
};

export const postCompleteProfile = async (body: ProfileCompleteReqDto): Promise<loginResponseType> => {
  const { data } = await apiClient.post('/member/profile', body);

  // NOTE: 현재 실패한 요청에도 http code를 200으로 받고 있기 때문에 아래와 같이 처리합니다
  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data.result;
};

/** 온보딩 나머지 항목을 건너뛰어도 여권 영문 성·이름은 남긴다. 가입 후속 처리(메일·쿠폰)는 일어나지 않는다. */
export const patchMemberName = async (body: { firstName: string; lastName: string }): Promise<string> => {
  const { data } = await apiClient.patch('/member/profile/name', body);

  // NOTE: 현재 실패한 요청에도 http code를 200으로 받고 있기 때문에 아래와 같이 처리합니다
  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data.result;
};
